module.exports = __webpack_public_path__ + "img/117.10.9e0e6abc.png";